import { useState } from 'react';
import SectionHeading from '@/pages/home/components/SectionHeading';
import { faqs } from '@/mocks/home';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-24 bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-5">
            <SectionHeading
              index="07"
              kicker="FAQ"
              title="常见问题：关于补课，大家常问这些"
              desc="如果你第一次来，五分钟就能上手。下面的问题覆盖了我们怎么整理、怎么更新、以及你该怎么看待站内内容。"
            />
            <div className="mt-8 hidden rounded-lg border border-background-200 bg-background-50 p-5 lg:block">
              <p className="font-label text-xs tracking-wide text-foreground-500">还有别的疑问？</p>
              <p className="mt-2 font-body text-sm text-foreground-700">
                把你想问的发到首页底部的邮箱，我们会挑高频问题补进这一栏。
              </p>
            </div>
          </div>

          <div className="lg:col-span-7">
            <ul className="space-y-3">
              {faqs.map((faq, i) => {
                const open = openIndex === i;
                return (
                  <li
                    key={faq.q}
                    className={`overflow-hidden rounded-lg border transition-colors ${
                      open ? 'border-primary-300 bg-background-50' : 'border-background-200 bg-background-50/60'
                    }`}
                  >
                    <button
                      type="button"
                      onClick={() => setOpenIndex(open ? null : i)}
                      aria-expanded={open}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer md:px-6 md:py-5"
                    >
                      <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                        {faq.q}
                      </span>
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                          open ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-700'
                        }`}
                      >
                        <i className={open ? 'ri-subtract-line' : 'ri-add-line'} />
                      </span>
                    </button>
                    {open && (
                      <div className="px-5 pb-5 md:px-6 md:pb-6">
                        <p className="border-t border-background-200 pt-4 font-body text-sm leading-relaxed text-foreground-600">
                          {faq.a}
                        </p>
                      </div>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}